// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__Wh5WG","columns":"Footer_columns__57d+f","column":"Footer_column__atv-M"};